import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';

interface ContentBlockDividerProps {}

export default function ContentBlockDivider(_props: ContentBlockDividerProps) {
	return <View style={styles.divider} />;
}

const styles = StyleSheet.create({
	divider: {
		backgroundColor: Platform.OS === 'ios' ? Colors.greyBg : Colors.overlay12,
		height: Platform.OS === 'ios' ? 5 : 0.5,
		flex: 1,
		marginTop: Platform.OS === 'ios' ? Dimens.margin10 : Dimens.margin12,
		marginBottom: Platform.OS === 'ios' ? Dimens.margin10 : Dimens.margin12,
	},
});
